module.exports = __webpack_public_path__ + "img/miryoku_t1.2e65b9b2.png";